import Coupons from 'Components/Coupons/Coupons';

export default Coupons;
